import { GetStaticPaths, GetStaticProps } from 'next'
import { AppLayout, Container, PartialContainer } from '@components'
import { NextSeo } from 'next-seo'
import { SpeakerDetail } from '@partials/tech-summit/SpeakerDetail'
import { querySummitSpeaker, querySummitSpeakers } from '@queries'
import { getGraphQLData } from 'database/graphQL/apollo'
import { ISpeaker } from 'pages/summit'

export const getStaticProps: GetStaticProps = async context => {
  const slug = context.params!.slug as string
  const response = await getGraphQLData<{ summitSpeaker: ISpeaker }>(
    querySummitSpeaker(slug),
  )
  const speaker = response?.summitSpeaker
  if (!speaker) {
    return {
      notFound: true,
    }
  }

  return {
    props: { speaker },
    revalidate: 10,
  }
}

export const getStaticPaths: GetStaticPaths = async () => {
  const response = await getGraphQLData<{ allSummitSpeakers: ISpeaker[] }>(
    querySummitSpeakers,
  )

  const speakers = response?.allSummitSpeakers

  const paths = speakers.map(speaker => {
    return { params: { slug: speaker.slug } }
  })

  return {
    paths,
    fallback: 'blocking',
  }
}

export default function SummitSpeaker({ speaker }: { speaker: ISpeaker }) {
  return (
    <AppLayout className="bg-[#EEF2FF]">
      <PartialContainer className="py-10 md:py-16">
        <NextSeo
          title={speaker.name}
          description={speaker.role}
          canonical={`https://www.marketxventures.com/summit/speakers/${speaker.slug}`}
          openGraph={{
            title: `${speaker.name} | MarketX Ventures Summit '23`,
            url: `https://www.marketxventures.com/summit/speakers/${speaker.slug}`,
          }}
        />
        <SpeakerDetail speaker={speaker} isPage />
      </PartialContainer>
    </AppLayout>
  )
}
